//
// --- Types ---

export type ItemSchemaNameKeyType = keyof typeof ITEM_SCHEMA_NAME;
export type ItemSchemaNameType = typeof ITEM_SCHEMA_NAME[ItemSchemaNameKeyType];

//
// --- Constants ---

export const ITEM_SCHEMA_NAME = {
  NON_POWERADVOCATE: 'NOTPASCHEMA',
  POWERADVOCATE: 'PASCHEMA'
} as const;
